import ContentInitialState from 'RLX/State/Content/ContentInitialState';

const ContentReducer = (state = ContentInitialState, { type, payload } = {}) => {
  switch (type) {

    case 'content/LOADED_SITE_DATA': {
      const { meta, blogs, pages } = payload;
      return { meta, blogs, pages };
    }

    case 'content/PAGE_ADDED': {
      const { page } = payload;
      const pages = [ ...state.pages, page ];
      return { ...state, pages };
    }

    case 'content/PAGE_DELETED': {
      const { pageId } = payload;
      const newPages = state.pages.filter(page => page.id !== pageId);
      return { ...state, pages: newPages };
    }

    case 'content/PAGE_UPDATED': {
      const { page } = payload;
      const pageIndex = state.pages.findIndex(({ id }) => id === page.id);
      if (pageIndex < 0) return state;
      const pages = [ ...state.pages ].map((_page, index) => {
        return (index !== pageIndex)
          ? _page
          : page;
      });
      return { ...state, pages };
    }

    case 'content/BLOG_ADDED': {
      const { blog } = payload;
      const blogs = [ ...state.blogs, blog ];
      return { ...state, blogs };
    }

    case 'content/BLOG_DELETED': {
      const { blogId } = payload;
      const blogs = state.blogs.filter(blog => blog.id !== blogId);
      return { ...state, blogs };
    }

    case 'content/BLOG_RENAMED': {
      const { oldBlogId, newBlogId } = payload;
      const blogIndex = state.blogs.findIndex(({ id }) => id === oldBlogId);
      if (blogIndex < 0) return state;
      const blogs = [ ...state.blogs ].map((_blog, index) => {
        return (index !== blogIndex)
          ? _blog
          : { ..._blog, id: newBlogId }
      });
      return { ...state, blogs };
    }

    case 'content/BLOG_UPDATED': {
      const { blog } = payload;
      const blogIndex = state.blogs.findIndex(({ id }) => id === blog.id);
      if (blogIndex < 0) return state;
      const blogs = [ ...state.blogs ].map((_blog, index) => {
        return (index !== blogIndex)
          ? _blog
          : blog;
      });
      return { ...state, blogs };
    }

    case 'content/SECTION_UPDATED': {
      const { pageId, section } = payload;
      const pages = state.pages.map((page, index) => {
        if (!page.content) return page;
        const content = page.content.map((_section, index) => {
          return page.id === pageId && _section.id === section.id
            ? section
            : _section;
        });
        return { ...page, content };
      });
      return { ...state, pages };
    }
    default:
      return state;
  }
};

export default ContentReducer;



// WEBPACK FOOTER //
// ./client/RLX/State/Content/ContentReducer.js